/**
 * @generated SignedSource<<75d87c9d68716383694ad69e3d8e3b59>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceVersionCloneButtonExistsQuery$variables = {
  owner: string;
  slug: string;
};
export type WorkspaceVersionCloneButtonExistsQuery$data = {
  readonly workspaceBySlug: {
    readonly id: string;
  } | null | undefined;
};
export type WorkspaceVersionCloneButtonExistsQuery = {
  response: WorkspaceVersionCloneButtonExistsQuery$data;
  variables: WorkspaceVersionCloneButtonExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      },
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Workspace",
    "kind": "LinkedField",
    "name": "workspaceBySlug",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceVersionCloneButtonExistsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceVersionCloneButtonExistsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "84ca3df135745de44b9aec60b7289524",
    "id": null,
    "metadata": {},
    "name": "WorkspaceVersionCloneButtonExistsQuery",
    "operationKind": "query",
    "text": "query WorkspaceVersionCloneButtonExistsQuery(\n  $owner: String!\n  $slug: String!\n) {\n  workspaceBySlug(owner: $owner, slug: $slug) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e249b9a92d79630f558c87b501bb99f";

export default node;
